import { createStore, applyMiddleware, compose } from "redux";
//middleware
import thunk from "redux-thunk";

import rootReducer from "./reducers";
//from index.js but as known no need to write it out

// import watch from "redux-watch";

// import callGetElements from "./stateChange";

// import { getElements } from "./actions/elementActions";
// import { getProjects } from "./actions/projectActions";
// import { getMenu } from "./actions/menuActions";
// import { pictureDownload, pictureUpload } from "./actions/pictureAction";
// import userReducer from "./reducers/userReducer";

const initialState = {};

const middleware = [thunk];

// redux store
const store = createStore(
  rootReducer, //-> so the store knows the rootReducer
  initialState,
  compose(applyMiddleware(...middleware)) // Problem in EDGE
  //for redux middleware we need to wrap middleware in compose
  //this means first window.. executed then the results given to
  //applyMiddleware and executed
);

// // assuming you have an admin reducer / state slice
// console.log(`skdjf ${store.getState().auth.isAuthenticated}`); // 'JP'

// // store is THE redux store
// let w = watch(store.getState, "auth.isAuthenticated");
// let img = watch(store.getState, "image.images");
// let isAuth = false;
// let imgLoaded = false;
// let r = watch(store.getState, "auth.isAuthenticated");

// store.subscribe(
//   w((newVal, oldVal, objectPath) => {
// console.log("isauth", oldVal, newVal);
// console.log("%s changed from %s to %s", objectPath, oldVal, newVal);
// admin.name changed from JP to JOE
// store.dispatch(getElements());
// store.dispatch(getProjects());
// isAuth = true;
// store.dispatch(getMenu());
// store.dispatch(pictureDownload());
// })
// );

// store.subscribe(
//   img((newVal, oldVal, objectPath) => {
//     // console.log("%s changed from %s to %s", objectPath, oldVal, newVal);
//     // admin.name changed from JP to JOE
//     // store.dispatch(getElements());
//     // store.dispatch(getProjects());
//     // if(isAuth&&!imgLoaded)
//     console.log("store img", newVal);
//     // store.dispatch(pictureDownload());
//   })
// );

// // somewhere else, admin reducer handles ADMIN_UPDATE
// store.dispatch({ type: "ADMIN_UPDATE", payload: { name: "JOE" } });

export default store;
